<app-modal *ngIf="vo$ | async; let vo" class="app-permissions-config-modal">
	<div class="app-permissions-config-modal__body" modal-body>
		<dc-alert
			type="info"
			message="info"
			i18n-message="@@subscription.permissions.update.description">
		</dc-alert>

		<ng-container>
			<app-panel
				headerHeight="3rem"
				isAlwaysOpen="true"
				hasRefresh="true"
				maxActionsCount="6"
				[itemsCount]="vo.list.elements.size"
				(refresh)="refresh()">
					<span
						panel-title
						i18n="@@permission.list.title">
						permissions</span>

					<app-permissions-config
						[permissionsConfig]="vo.list"
						[config]="config"></app-permissions-config>

			</app-panel>
		</ng-container>
	</div>
	<div modal-footer class="app-permissions-config-modal__footer">
		<button
			id="{{ cmpId }}-update-btn"
			[color]="'primary'"
			mat-raised-button
			(click)="updatePermissions()">
			<span
				i18n="@@general.action.update">
				update</span>
		</button>
	</div>
</app-modal>
